import { Tooltip } from '@components/Tooltip/Tooltip';
import { useStrings } from '@hooks/useStrings';
import { CloseButtonContainer } from '../CloseAction/CloseButtonContainer';
import { CloseIcon } from '../CloseAction/CloseIcon';
import type { CloseActionProps } from '../CloseAction/CloseAction';

/**
 * Additional options for the clear action.
 */
export interface ClearActionProps extends CloseActionProps {
  /**
   * Text to show in the action tooltip.
   * Defaults to 'Clear'.
   */
  actionText?: string;
}

/**
 * ClearAction component.
 *
 * {@link https://zeroheight.com/76c439891/p/542b55-common-actions/t/49b4eb Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-clearaction Code documentation}
 *
 * @example
 * <ClearAction onClick={() => {}} description="Clear search" />
 */
export const ClearAction = ({
  actionText,
  description,
  ...props
}: ClearActionProps): JSX.Element => {
  const { actions } = useStrings();
  const finalActionText = actionText || actions.clear;

  return (
    <Tooltip text={finalActionText}>
      <CloseButtonContainer {...props} aria-label={description} type="button">
        <CloseIcon description={description} />
      </CloseButtonContainer>
    </Tooltip>
  );
};

ClearAction.defaultProps = {
  isColorInverted: false,
};
